import { useQuery } from '@tanstack/react-query';
import * as currentUserService from '@services/currentUser';

export const USER_ORGANIZATIONS_QUERY_KEY = ['userOrganizations'];

export const useUserOrganizations = () => {
  return useQuery({
    queryKey: USER_ORGANIZATIONS_QUERY_KEY,
    queryFn: async () => {
      const response = await currentUserService.getUserOrganizations();
      return response.getUserOrganizations;
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};
